import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import TableDataNotFound from "component/TableDataNotFound";
import { handleListResponse, seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import { newUploadStatus } from "utils/constants";
import { bulkVerifyVisitList } from "reduxStore/action/visitorActions";
import { VISITOR_STATUS_UPDATE } from "../../reduxStore/types";
import { getConfiguration } from "reduxStore/action/masterActions";
import Pagination from "component/common/Pagination";
import usePage from "utils/usePage";

const VerifyLead = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const visitorConfiguration = useSelector(
    (state) => state.visitorConfiguration
  );
  const [visitorConfigurationData, setvisitorConfigurationData] = useState([]);

  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    lead_status: "",
    search_by_name: "",
    configuration_id: "",
  });

  const [getbulkVerifyVisitorList, setbulkVerifyVisitorList] = useState([]);

  const bulkVerifyVisitoListSelector =
    useSelector((state) => state?.visitor) || [];

  const bulkVisitStatusSelector = useSelector((state) => state?.visitor) || [];

  useEffect(() => {
    if (bulkVerifyVisitoListSelector?.response?.status === 200) {
      setbulkVerifyVisitorList(
        handleListResponse(bulkVerifyVisitoListSelector?.response?.data)
      );
    } else {
      setbulkVerifyVisitorList([]);
    }
  }, [bulkVerifyVisitoListSelector]);

  useEffect(() => {
    dispatch(bulkVerifyVisitList({ limit: 10, offset: page }));
  }, [bulkVerifyVisitList]);

  useEffect(() => {
    if (visitorConfiguration?.response) {
      const { response } = visitorConfiguration;
      if (response?.status === 200) {
        setvisitorConfigurationData(response.data);
      } else {
        setvisitorConfigurationData([]);
      }
    }
  }, [visitorConfiguration]);

  useEffect(() => {
    dispatch(getConfiguration());
  }, []);

  useEffect(() => {
    if (bulkVisitStatusSelector?.userData?.status === 200) {
      dispatch({
        type: VISITOR_STATUS_UPDATE,
        payload: null,
      });
      dispatch(bulkVerifyVisitList({ limit: 10, offset: page }));
    }
  }, [bulkVisitStatusSelector]);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        bulkVerifyVisitList({
          limit: 10,
          offset: 0,
          start_date: form.start_date,
          end_date: form.end_date,
          lead_status: form.lead_status,
          configuration_id: form.configuration_id,
          search_by_name: form.search_by_name,
        })
      );
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      lead_status: "",
      configuration_id: "",
      search_by_name: "",
    });
    setFormVaild({
      ...formVaild,
      end_date: ""
    })
    dispatch(bulkVerifyVisitList({ limit: 10, offset: 0 }));
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    dispatch(
      bulkVerifyVisitList({
        limit: 10,
        offset: newOffset,
        start_date: form.start_date,
        end_date: form.end_date,
        lead_status: form.lead_status,
        configuration_id: form.configuration_id,
        search_by_name: form.search_by_name,
      })
    );
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: ""
      })
    }
  };

  // Disable end_date
  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Verify Lead Listing",
      metaDescription: "Verify lead listing",
      canonicalLink: window.location.href,
    });
  }, []);

  const { view, create } = usePermission({
    view: "view_verify_lead",
    create: "add_verify_lead",
  });

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.VerifyVisitor}
        titleactive={strings.verifyListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByVisitorName}
                          </span>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="text"
                            autoComplete="off"
                            placeholder={strings.searchVisitorName}
                            name="search_by_name"
                            value={form.search_by_name}
                            onChange={handleInputField}
                          />
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByConfiguration}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="configuration_id"
                            value={form.configuration_id}
                            onChange={handleInputField}
                          >
                            <option value="">
                              {strings.selectConfiguration}
                            </option>
                            {visitorConfigurationData?.length ? (
                              visitorConfigurationData.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.title}
                                </option>
                              ))
                            ) : (
                              <option>{strings.Loading}</option>
                            )}
                          </select>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByStatus}
                          </span>
                          <select
                            className="form-control digits"
                            id="formcontrol-select1"
                            name="lead_status"
                            onChange={handleInputField}
                            value={form.lead_status}
                          >
                            <option defaultValue={""}>
                              {strings.selectstatus}
                            </option>
                            <option value={1}>{strings.panding}</option>
                            <option value={2}>{strings.verify}</option>
                            <option value={3}>{strings.close}</option>
                          </select>
                        </div>
                        <div className="col-md-4 pt-4">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning  mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.listOfVerifyVisitor}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.propertyname}</th>
                          <th scope="col">{strings.visitorName}</th>
                          <th scope="col">{strings.source}</th>
                          <th scope="col">{strings.configuration}</th>
                          <th scope="col">{strings.budget}</th>
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {getbulkVerifyVisitorList?.length > 0 ? (
                          getbulkVerifyVisitorList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  {item.property_title
                                    ? item.property_title
                                    : "-"}
                                </td>
                                <td>{item.first_name ? item.first_name : "-"}</td>
                                <td>{item.user_name}</td>
                                <td>
                                  {item?.configuration
                                    ? item.configuration
                                    : "-"}
                                </td>
                                <td>
                                  {item?.min_budget}
                                  {item.min_budget
                                    ? item.min_budget_type
                                    : null}
                                  {" - "}
                                  {item?.max_budget}
                                  {item.max_budget
                                    ? item.max_budget_type
                                    : null}
                                </td>
                                <td>{newUploadStatus[item?.lead_status]}</td>
                                {item?.lead_status === 1 ?
                                  <td className="p-2">
                                    {view && (
                                      <i
                                        className="fa fa-eye theme-fa-icon p-2 mr-1"
                                        aria-hidden="true"
                                        title={strings.viewVerifyLead}
                                        onClick={() => {
                                          let leadId = "";
                                          if (item.lead_id) {
                                            leadId = `?lead_id=${item.lead_id}`;
                                          }
                                          navigatpage(
                                            `/view_verify_lead/${item._id}${leadId}`
                                          );
                                        }}
                                      ></i>
                                    )}
                                    {create && (
                                      <i
                                        className="fa fa-edit theme-fa-icon"
                                        aria-hidden="true"
                                        title={strings.addVerifyLead}
                                        onClick={() => {
                                          let leadId = "";
                                          if (item.lead_id) {
                                            leadId = `?lead_id=${item.lead_id}`;
                                          }
                                          navigatpage(
                                            `/createLead/${item._id}${leadId}`
                                          );
                                        }}
                                      ></i>
                                    )}
                                  </td> : <td className="p-2">{"-"}</td>}
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={getbulkVerifyVisitorList} />
                  </div>
                  <Pagination
                    totalCount={
                      bulkVerifyVisitoListSelector?.response?.total_data
                    }
                    listData={getbulkVerifyVisitorList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VerifyLead;
